import { NavLink } from 'react-router-dom';
import './BackLink.css';

const BackLink = ({ to, label }) => (
  <NavLink to={to} className="back-link">
    <span className="material-symbols-outlined">arrow_back</span>
    {label}
  </NavLink>
);

export default BackLink;
